export default __webpack_public_path__ + "static/media/howto-img-02@medium.695dd847.jpg";